import Vue from 'vue'
import Router from 'vue-router'
import { BasicLayout } from '@/layouts';

import Topic from '../pages/Topic.vue'
import PersonInfo from '../pages/personInfo.vue'
import Studio from '../pages/studio.vue'
import MemberInfo from '../pages/memberInfo.vue'
import MemberDetail from '../pages/memberDetail.vue'
import Pupil from '../pages/pupil.vue'
import PupilDetail from '../pages/pupilDetail.vue'

import Exp from '../pages/exp.vue'
import ExpDetail from '../pages/expDetail.vue'
import Case from '../pages/case.vue'
import CaseDetail from '../pages/caseDetail.vue'
import Achieve from '../pages/achieve.vue'
import AchieveDetail from '../pages/achieveDetail.vue'
import Talent from '../pages/talent.vue'
import TalentDetail from '../pages/talentDetail.vue'
import News from '../pages/news.vue'
import NewsDetail from '../pages/newsDetail.vue'
import Media from '../pages/media.vue'
import Science from '../pages/science.vue'
import Video from '../pages/video.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes:[
        {
            path: '/',
            component: BasicLayout,
            redirect: '/topic',
            children: [{
                path: '/topic',
                name: 'topic',
                component: { render: h => h('router-view') },
                redirect: '/topic',
                children: [{
                        path: '/topic',
                        component: Topic,
                    }]
            }]
        },
        {
            path: '/personInfo',
            component: BasicLayout,
            redirect: '/personInfo',
            children: [{
                path: '/personInfo',
                name: 'personInfo',
                component: { render: h => h('router-view') },
                redirect: '/personInfo',
                children: [{
                        path: '/personInfo',
                        component: PersonInfo,
                    }]
            }]
        },
        {
            path: '/studio',
            component: BasicLayout,
            redirect: '/studio',
            children: [{
                path: '/studio',
                name: 'studio',
                component: { render: h => h('router-view') },
                redirect: '/studio',
                children: [{
                        path: '/studio',
                        component: Studio,
                    }]
            }]
        },
        {
            path: '/memberInfo',
            component: BasicLayout,
            redirect: '/memberInfo',
            children: [{
                path: '/memberInfo',
                name: 'memberInfo',
                component: { render: h => h('router-view') },
                redirect: '/memberInfo',
                children: [{
                        path: '/memberInfo',
                        component: MemberInfo,
                    }]
            }]
        },
        {
            path: '/memberDetail',
            component: BasicLayout,
            redirect: '/memberDetail',
            children: [{
                path: '/memberDetail',
                name: 'memberDetail',
                component: { render: h => h('router-view') },
                redirect: '/memberDetail',
                children: [{
                        path: '/memberDetail',
                        component: MemberDetail,
                    }]
            }]
        },
        {
            path: '/pupil',
            component: BasicLayout,
            redirect: '/pupil',
            children: [{
                path: '/pupil',
                name: 'pupil',
                component: { render: h => h('router-view') },
                redirect: '/pupil',
                children: [{
                        path: '/pupil',
                        component: Pupil,
                    }]
            }]
        },
        {
            path: '/pupilDetail',
            component: BasicLayout,
            redirect: '/pupilDetail',
            children: [{
                path: '/pupilDetail',
                name: 'pupilDetail',
                component: { render: h => h('router-view') },
                redirect: '/pupilDetail',
                children: [{
                        path: '/pupilDetail',
                        component: PupilDetail,
                    }]
            }]
        },
        {
            path: '/exp',
            component: BasicLayout,
            redirect: '/exp',
            children: [{
                path: '/exp',
                name: 'exp',
                component: { render: h => h('router-view') },
                redirect: '/exp',
                children: [{
                        path: '/exp',
                        component: Exp,
                    }]
            }]
        },
        {
            path: '/expDetail',
            component: BasicLayout,
            redirect: '/expDetail',
            children: [{
                path: '/expDetail',
                name: 'expDetail',
                component: { render: h => h('router-view') },
                redirect: '/expDetail',
                children: [{
                        path: '/expDetail',
                        component: ExpDetail,
                    }]
            }]
        },
        {
            path: '/case',
            component: BasicLayout,
            redirect: '/case',
            children: [{
                path: '/case',
                name: 'case',
                component: { render: h => h('router-view') },
                redirect: '/case',
                children: [{
                        path: '/case',
                        component: Case,
                    }]
            }]
        },
        {
            path: '/caseDetail',
            component: BasicLayout,
            redirect: '/caseDetail',
            children: [{
                path: '/caseDetail',
                name: 'caseDetail',
                component: { render: h => h('router-view') },
                redirect: '/caseDetail',
                children: [{
                        path: '/caseDetail',
                        component: CaseDetail,
                    }]
            }]
        },
        {
            path: '/achieve',
            component: BasicLayout,
            redirect: '/achieve',
            children: [{
                path: '/achieve',
                name: 'achieve',
                component: { render: h => h('router-view') },
                redirect: '/achieve',
                children: [{
                        path: '/achieve',
                        component: Achieve,
                    }]
            }]
        },
        {
            path: '/achieveDetail',
            component: BasicLayout,
            redirect: '/achieveDetail',
            children: [{
                path: '/achieveDetail',
                name: 'achieveDetail',
                component: { render: h => h('router-view') },
                redirect: '/achieveDetail',
                children: [{
                        path: '/achieveDetail',
                        component: AchieveDetail,
                    }]
            }]
        },
        {
            path: '/talent',
            component: BasicLayout,
            redirect: '/talent',
            children: [{
                path: '/talent',
                name: 'talent',
                component: { render: h => h('router-view') },
                redirect: '/talent',
                children: [{
                        path: '/talent',
                        component: Talent,
                    }]
            }]
        },
        {
            path: '/talentDetail',
            component: BasicLayout,
            redirect: '/talentDetail',
            children: [{
                path: '/talentDetail',
                name: 'talentDetail',
                component: { render: h => h('router-view') },
                redirect: '/talentDetail',
                children: [{
                        path: '/talentDetail',
                        component: TalentDetail,
                    }]
            }]
        },
        {
            path: '/news',
            component: BasicLayout,
            redirect: '/news',
            children: [{
                path: '/news',
                name: 'news',
                component: { render: h => h('router-view') },
                redirect: '/news',
                children: [{
                        path: '/news',
                        component: News,
                    }]
            }]
        },
        {
            path: '/newsDetail',
            component: BasicLayout,
            redirect: '/newsDetail',
            children: [{
                path: '/newsDetail',
                name: 'newsDetail',
                component: { render: h => h('router-view') },
                redirect: '/newsDetail',
                children: [{
                        path: '/newsDetail',
                        component: NewsDetail,
                    }]
            }]
        },
        {
            path: '/media',
            component: BasicLayout,
            redirect: '/media',
            children: [{
                path: '/media',
                name: 'media',
                component: { render: h => h('router-view') },
                redirect: '/media',
                children: [{
                        path: '/media',
                        component: Media,
                    }]
            }]
        },
        {
            path: '/science',
            component: BasicLayout,
            redirect: '/science',
            children: [{
                path: '/science',
                name: 'science',
                component: { render: h => h('router-view') },
                redirect: '/science',
                children: [{
                        path: '/science',
                        component: Science,
                    }]
            }]
        },
        {
            path: '/video',
            component: BasicLayout,
            redirect: '/video',
            children: [{
                path: '/video',
                name: 'video',
                component: { render: h => h('router-view') },
                redirect: '/video',
                children: [{
                        path: '/video',
                        component: Video,
                    }]
            }]
        }
    ]
})